import {EquipmentData, EquipmentPlain, Iso8601, SapDataDto, User} from '@hconnect/common/types'

import {TaskAssignee, TaskSource, TaskStatus} from './task.types'

export const OIL_ANALYSIS_ACTION_STATUSES = [
  TaskStatus.Pending,
  TaskStatus.Ongoing,
  TaskStatus.Done
] as const

export type OilAnalysisActionStatus = (typeof OIL_ANALYSIS_ACTION_STATUSES)[number]

export enum OilAnalysisActionPriority {
  Immediately = 'immediately',
  OneDay = 'oneDay',
  OneWeek = 'oneWeek',
  OneMonth = 'oneMonth'
}

export type OilAnalysisProperties = {
  assignee?: string
  functionalLocation?: string
  processStage?: string
  sapPmWorkOrder?: string
  comment?: string
  criticality?: string | null
}

export type OilAnalysisActionFormValues = {
  plantUpmId: string
  source: TaskSource
  status: OilAnalysisActionStatus
  title: string
  description: string
  dueDate?: Iso8601 | null
  priority?: OilAnalysisActionPriority
  functionalLocation?: string | null
  equipment?: EquipmentPlain
  mainEquipment?: EquipmentData
  processStage?: string | null
  assignees: User[]
}

export type OilAnalysisActionDto = {
  id: string
  actionId: string
  plantUpmId: string
  title: string
  description: string
  status: OilAnalysisActionStatus
  createdOn: Iso8601
  createdBy: string
  lastModified?: Iso8601
  dueDate: Iso8601 | null
  priority?: OilAnalysisActionPriority
  oilAnalysisProperties: OilAnalysisProperties
  assignees: TaskAssignee[]
  equipment: EquipmentData
  mainEquipment?: EquipmentData
  processStage?: string
  sapInfo?: SapDataDto
}

export type EditOilAnalysisActionDto = {
  title: string
  description: string
  status: OilAnalysisActionStatus
  dueDate: Iso8601 | null
  priority?: OilAnalysisActionPriority
  functionalLocation?: string | null
  equipmentId?: string
  equipmentIdType?: string
  equipmentText?: string
  mainEquipmentId?: string
  mainEquipmentIdType?: string
  mainEquipmentText?: string
  processStage?: string | null
  assignees: string[]
}

export type EditOilAnalysisAction = EditOilAnalysisActionDto & {
  id: string
  plantUpmId: string
}

export type CreateOilAnalysisMaintenanceNotificationActionDto = {
  workCenterId?: string
  plannerGroupId?: string
}
